// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This style file is imported by LoginModel.js which is called by LoginPage.js.
*/

.auth-container {
  width: 100%;
  max-width: 400px;
  margin: 2rem auto;
  padding: 2rem;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.auth-container img {
  width: 70%;
  margin-left: 15%;
}

.auth-header {
  display: flex;
  margin-bottom: 2rem;
  border-bottom: 2px solid #f0f0f0;
}

.auth-header-button {
  flex: 1 1;
  padding: 1rem;
  font-size: 1.1rem;
  font-weight: 500;
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #666;
}

.auth-header-button.active {
  color: #0C3135;
  border-bottom: 2px solid #0C3135;
  margin-bottom: -2px;
}

.auth-header-button:hover:not(.active) {
  color: #0C3135;
  background-color: #f5f5f5;
}

.form-group {
  margin-bottom: 1.5rem;
  position: relative;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
  font-size: 0.95rem;
}

.form-group input {
  width: 100%;
  height: 48px;
  padding: 0.8rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-sizing: border-box;
  background-color: #fff;
}

.form-group input:focus {
  outline: none;
  border-color: #0C3135;
  box-shadow: 0 0 0 2px rgba(12, 49, 53, 0.1);
}

.form-group input::placeholder {
  color: #999;
}

.form-group input:hover {
  border-color: #0C3135;
}

.auth-button {
  width: 100%;
  height: 48px;
  padding: 0;
  background-color: #0C3135;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-button:hover {
  background-color: #0a2729;
}

.auth-button:active {
  transform: translateY(1px);
}

.form-group input.error {
  border-color: #f44336;
  background-color: #fff8f8;
}

.error-message {
  color: #f44336;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.success-message {
  color: #4caf50;
  text-align: center;
  margin-top: 1rem;
  padding: 0.75rem;
  background-color: #e8f5e9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.auth-button.loading {
  background-color: #0C3135;
  cursor: not-allowed;
  opacity: 0.8;
}

input[type="password"]::-ms-reveal,
input[type="password"]::-ms-clear,
input[type="password"]::-webkit-contacts-auto-fill-button,
input[type="password"]::-webkit-credentials-auto-fill-button {
  display: none !important;
}

/* For Webkit browsers (Chrome, Safari) */
input[type="password"]::-webkit-inner-spin-button,
input[type="password"]::-webkit-search-decoration,
input[type="password"]::-webkit-search-cancel-button,
input[type="password"]::-webkit-search-results-button,
input[type="password"]::-webkit-search-results-decoration {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/LoginSignup/LoginModel.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA,yCAAyC;AACzC;;;;;EAKE,aAAa;AACf","sourcesContent":["/*\nThis style file is imported by LoginModel.js which is called by LoginPage.js.\n*/\n\n.auth-container {\n  width: 100%;\n  max-width: 400px;\n  margin: 2rem auto;\n  padding: 2rem;\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\n}\n\n.auth-container img {\n  width: 70%;\n  margin-left: 15%;\n}\n\n.auth-header {\n  display: flex;\n  margin-bottom: 2rem;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.auth-header-button {\n  flex: 1;\n  padding: 1rem;\n  font-size: 1.1rem;\n  font-weight: 500;\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: #666;\n}\n\n.auth-header-button.active {\n  color: #0C3135;\n  border-bottom: 2px solid #0C3135;\n  margin-bottom: -2px;\n}\n\n.auth-header-button:hover:not(.active) {\n  color: #0C3135;\n  background-color: #f5f5f5;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n  position: relative;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #333;\n  font-size: 0.95rem;\n}\n\n.form-group input {\n  width: 100%;\n  height: 48px;\n  padding: 0.8rem 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n  background-color: #fff;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #0C3135;\n  box-shadow: 0 0 0 2px rgba(12, 49, 53, 0.1);\n}\n\n.form-group input::placeholder {\n  color: #999;\n}\n\n.form-group input:hover {\n  border-color: #0C3135;\n}\n\n.auth-button {\n  width: 100%;\n  height: 48px;\n  padding: 0;\n  background-color: #0C3135;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.auth-button:hover {\n  background-color: #0a2729;\n}\n\n.auth-button:active {\n  transform: translateY(1px);\n}\n\n.form-group input.error {\n  border-color: #f44336;\n  background-color: #fff8f8;\n}\n\n.error-message {\n  color: #f44336;\n  font-size: 0.875rem;\n  margin-top: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.success-message {\n  color: #4caf50;\n  text-align: center;\n  margin-top: 1rem;\n  padding: 0.75rem;\n  background-color: #e8f5e9;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.auth-button.loading {\n  background-color: #0C3135;\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\ninput[type=\"password\"]::-ms-reveal,\ninput[type=\"password\"]::-ms-clear,\ninput[type=\"password\"]::-webkit-contacts-auto-fill-button,\ninput[type=\"password\"]::-webkit-credentials-auto-fill-button {\n  display: none !important;\n}\n\n/* For Webkit browsers (Chrome, Safari) */\ninput[type=\"password\"]::-webkit-inner-spin-button,\ninput[type=\"password\"]::-webkit-search-decoration,\ninput[type=\"password\"]::-webkit-search-cancel-button,\ninput[type=\"password\"]::-webkit-search-results-button,\ninput[type=\"password\"]::-webkit-search-results-decoration {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
